import { useState } from "react";
import { Stack } from "@mui/material";
import {
  FILE_NAME_LENGTH_LIMIT,
  getMaxUploadSizeInMegabytes,
  isUploadSizeLimitExceeded,
  isValidUploadableFile,
} from "../../../services/mediaObjectService";
import { Dropzone } from "../../Dropzone/Dropzone";

type LegalbirdDropzoneProps = {
  files: File[];
  setFiles: Function;
  acceptedFiles?: Array<string>;
  key?: number;
};

export default function LegalbirdDropzone({ files, setFiles, acceptedFiles, key }: LegalbirdDropzoneProps) {
  const [error, setError] = useState<string | null>(null);

  const handleChange = (files: File[]) => {
    for (const file of files) {
      if (!isValidUploadableFile(file.name)) {
        setError(
          `Dateiname hat ein falsches Format. Bitte prüfen, dass der Dateiname nicht länger als ${FILE_NAME_LENGTH_LIMIT} Zeichen ist und keine Sonderzeichen, Leerzeichen oder Punkte vorhanden sind.`,
        );
        setFiles([]);
        return;
      }

      if (isUploadSizeLimitExceeded(file)) {
        setError(
          `Ihre Datei ist leider zu groß. Die maximale Dateigröße ist ${getMaxUploadSizeInMegabytes(file)} MB.`,
        );
        setFiles([]);
        return;
      }
    }

    setError(null);
    setFiles(files);
  };

  return (
    <Stack
      sx={{
        gap: "1rem",
        padding: "1rem 0",
      }}
    >
      <Dropzone
        key={key}
        onChange={handleChange}
        filesLimit={1}
        dropzoneText={"Datei hierher ziehen oder Fläche anklicken"}
        fileObjects={files}
        acceptedFiles={acceptedFiles}
        clearOnUnmount={true}
        error={error}
      />
    </Stack>
  );
}
